<template>
  <div>
    <loading-animation
      :active.sync="loading"
      :is-full-page="false"
      :opacity="1"
      color="#5895FF"
    />
    <div id="boxPrint" class="row">
      <div class="col-md-12">
        <h4 class="text-center">
          {{
            $t(
              "Detalhes do Grupo do Serviço de Convivência e Fortalecimento de Vinculos"
            )
          }}
        </h4>
        <print-header></print-header>
        <table
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
        >
          <tbody>
            <tr>
              <td>
                PROTOCOLO: <strong>{{ item.protocolo }}</strong>
              </td>
              <td>
                CADASTRADO:
                <strong>{{ item.cadastrado }}</strong>
              </td>
              <td>
                ATUALIZADO:
                <strong>{{ item.atualizado }}</strong>
              </td>
              <td>
                STATUS:
                <b v-html="item.status_nome"></b>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                TÉCNICO RESPONSÁVEL:
                <b v-if="item.responsavel">{{ item.responsavel.name }}</b> -
                <span>{{ item.tecnico.profissao ?? "Não informado" }}</span>
              </td>
              <td colspan="2">
                UNIDADE:
                <b v-if="item.unidade">{{ item.unidade.nome }}</b>
              </td>
            </tr>

            <tr>
              <td>
                NOME DO GRUPO: <b>{{ item.nome_grupo }}</b>
              </td>
              <td>
                FAIXA ETÁRIA:
                <b>{{ item.faixa_etaria_nome }}</b>
              </td>
              <td>
                ACESSO: <b>{{ item.acesso_nome }}</b>
              </td>
              <td>
                PERIODICIDADE:
                <b>{{ item.periodicidade_nome }}</b>
              </td>
            </tr>

            <tr>
              <td colspan="3">
                DIAS DA SEMANA:
                <b>{{ item.dias_semana_nomes }}</b>
              </td>
              <td>
                HORÁRIO: <b>{{ item.horario | formatHora }}</b>
              </td>
            </tr>

            <tr>
              <td>
                VAGAS: <b>{{ item.numero_vagas }}</b>
              </td>
              <td>
                CARGA HORÁRIA:
                <b>{{ item.carga_horaria }} hora(s)</b>
              </td>
              <td>
                CARATER <b>{{ item.carater_nome }}</b>
              </td>
              <td>
                FORMA DE EXECUÇÃO
                <b>{{ item.forma_execucao_nome }}</b>
              </td>
            </tr>
            <tr v-if="item.forma_execucao == 2">
              <td v-if="item.unidade_osc" colspan="4">
                UNIDADE DE EXECUTORA:
                <b>
                  {{ item.unidade_osc.nome }}
                </b>
              </td>
            </tr>

            <tr>
              <td colspan="2">
                UNIDADE BASE FÍSICA DOS GRUPOS:
                <b v-if="item.unidade_base">{{ item.unidade_base.nome }}</b>
              </td>
              <td colspan="2">
                ORIENTADOR SOCIAL:
                <b v-if="item.orientador_social">{{
                  item.orientador_social.nome
                }}</b>
              </td>
            </tr>

            <tr v-if="item.facilitador_social">
              <td colspan="4">
                FACILITADOR SOCIAL:
                <b>{{ item.facilitador_social.nome }}</b>
              </td>
            </tr>
            <tr v-if="item.data_sisc">
              <td colspan="2">
                IMPORTADO DO SISC? <b>{{ item.data_sisc }}</b>
              </td>
            </tr>

            <tr>
              <td colspan="2" class="text-center">
                <br />
                <hr />
                <span v-if="item.responsavel">
                  <b>{{ item.responsavel.name }}</b>
                  <br />
                  Técnico de Referência
                </span>
              </td>
              <td colspan="2" class="text-center">
                <br />
                <hr />
                <span v-if="item.orientador_social">
                  <b>{{ item.orientador_social.nome }}</b>
                  <br />
                  Orientador Social
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <print-footer
          v-if="item.tecnico.assinatura_digital"
          :tecnico="item.tecnico"
          class="mt-0"
          :assinatura="item.tecnico.assinatura_digital"
          :wpp="wpp"
          :email="email"
        />

        <p class="text-muted small" v-if="item.unidade">
          {{ app_cidade }}, {{ app_data_atual }} -
          {{ item.unidade.nome }}
        </p>

        <div class="row pt-4 px-0 d-flex justify-content-end no-print">
          <div class="col-auto px-2 text-right">
            <form-toggle
                grid="12"
                mt="0"
                v-model="email"
                label="Email"
            />
            <form-toggle
                grid="12"
                mt="0"
                v-model="wpp"
                label="Telefone/WhatsApp"
            />
            <router-link to="/dashboard/scfv" class="btn btn-default">
              <i class="mdi mdi-arrow-left" />
            </router-link>

            <a class="btn btn-sm py-1 btn-primary" @click="print()">
              <i class="mdi mdi-printer mdi-18px" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Show",
  data() {
    return {
      loading: true,
      item: {},
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      servicos: [],
      unidades: [],
      email: true,
      wpp: true
    };
  },
  mounted() {
    this.getItem();
  },
  methods: {
    getItem() {
      axios
        .get(`api/dashboard/scfv/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: "O item não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        });
    },
    verificarValueArray(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
    print() {
      const modal = document.getElementById("boxPrint");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },
  },
};
</script>

<style scoped>
@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }

  #print,
  #print * {
    visibility: visible;
  }

  #print {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
